import { jsx as _jsx } from "react/jsx-runtime";
import { Trans, useTranslation } from '@zurich/common/hooks';
import { Typography } from '@zurich/ui/legacy/components';
import { useAppImage } from '@zurich/ui/legacy/hooks';
import { styled } from '@zurich/ui/legacy/utils';
import Illustration from '../../images/Illustration_Dryness_RGB.svg';
import { InfoCard, InfoCardLink } from './InfoCard';
export const InfoCardEmpty = ({ partyId, simpleView = false, isUsedInClaim, }) => {
    const { t } = useTranslation();
    const AppImage = useAppImage();
    function renderInfocardTextsAndLinks() {
        if (simpleView) {
            return {
                lnk: _jsx(InfoCardLink, { href: `/party/${partyId}/offer` }),
                text: t('portal:emptyCard.descriptionSimpleViewNoPolicies'),
            };
        }
        return {
            lnk: partyId ? _jsx(InfoCardLink, { href: `/party/${partyId}` }) : _jsx("span", {}),
            text: t('portal:emptyCard.description'),
        };
    }
    const { text, lnk } = renderInfocardTextsAndLinks();
    return (_jsx(InfoCard, { title: _jsx(Typography, { variant: "h4", children: t(`portal:emptyCard.${isUsedInClaim ? 'descriptionSimpleViewNoClaims' : 'title'}`) }), description: !isUsedInClaim && (_jsx(TranslationStyled, { children: _jsx(Trans, { i18nKey: text, components: {
                    lnk,
                } }) })), illustration: _jsx(AppImage, { src: Illustration, alt: t('portal:emptyCard.title') }) }));
};
const TranslationStyled = styled('div')({
    whiteSpace: 'pre-wrap',
});
